<template>
  <div style="padding: 0 16px">
    <a-skeleton :loading="spinning" active avatar>
      <a-table :columns="columns" :pagination="pagination" :data-source="records" size="small" row-key="index" @change="handleTableChange">
        <span slot="number" slot-scope="record">{{ record.index }}</span>
        <span slot="operator" slot-scope="operator">{{ operator ? operator.nickname : '系统' }}</span>
        <span slot="diffItem" slot-scope="record">
          <div v-for="(item, key) in record.value_diff" :key="key">{{ item.label }}</div>
        </span>
        <span slot="before" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="item.value === 'title'">{{ item.before || '--' }}</div>
              <div v-else-if="item.value === 'status'">
                <a-tag v-if="item.before !== null && problemStatus[item.before]" :color="problemStatus[item.before].color">{{ problemStatus[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'urgency'">{{ item.before !== null ? problemUrgencys[item.before].label : '--' }}</div>
              <div v-else-if="item.value === 'channel'">{{ item.before !== null ? problemChannels[item.before].label : '--' }}</div>
              <div v-else-if="item.value === 'frequency'">
                <a-tag v-if="item.before !== null" :color="problemFrequencys[item.before].color">{{ problemFrequencys[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'level'">
                <a-tag v-if="item.before !== null" :color="faultLevels[item.before].color">{{ faultLevels[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'content'">
                <a v-if="item.before !== null" @click="onPreview(item.before, '「变更前」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'problem_type'">
                <a-badge v-if="item.before !== null" :color="problemTypes[item.before].color" :text="problemTypes[item.before].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'attribution'">
                <a v-if="item.before !== null" @click="onPreview(item.before, '「变更后」归因分析')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'tags'">{{ item.before ? item.before.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'domains'">{{ item.before ? item.before.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'projects'">{{ item.before ? item.before.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'handler'">{{ item.before ? item.before.nickname : '--' }}</div>
              <div v-else-if="item.value === 'reporter'">{{ item.before ? item.before.nickname : '--' }}</div>
              <div v-else-if="item.value === 'solver'">{{ item.before ? item.before.nickname : '--' }}</div>
              <div v-else-if="item.value === 'started_time'">{{ item.before ? item.before : '--' }}</div>
              <div v-else-if="item.value === 'reported_time'">{{ item.before ? item.before : '--' }}</div>
              <div v-else-if="item.value === 'resolved_time'">{{ item.before ? item.before : '--' }}</div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
        <span slot="after" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="item.value === 'title'">{{ item.after || '--' }}</div>
              <div v-else-if="item.value === 'status'">
                <a-tag v-if="item.after !== null && problemStatus[item.after]" :color="problemStatus[item.after].color">{{ problemStatus[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'urgency'">{{ item.after !== null ? problemUrgencys[item.after].label : '--' }}</div>
              <div v-else-if="item.value === 'channel'">{{ item.after !== null ? problemChannels[item.after].label : '--' }}</div>
              <div v-else-if="item.value === 'frequency'">
                <a-tag v-if="item.after !== null" :color="problemFrequencys[item.after].color">{{ problemFrequencys[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'level'">
                <a-tag v-if="item.before !== null" :color="faultLevels[item.after].color">{{ faultLevels[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'content'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'problem_type'">
                <a-badge v-if="item.after" :color="problemTypes[item.after].color" :text="problemTypes[item.after].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'attribution'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」归因分析')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'tags'">{{ item.after ? item.after.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'domains'">{{ item.after ? item.after.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'projects'">{{ item.after ? item.after.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'handler'">{{ item.after ? item.after.nickname : '--' }}</div>
              <div v-else-if="item.value === 'reporter'">{{ item.after ? item.after.nickname : '-/-' }}</div>
              <div v-else-if="item.value === 'solver'">{{ item.after ? item.after.nickname : '--' }}</div>
              <div v-else-if="item.value === 'started_time'">{{ item.after ? item.after : '--' }}</div>
              <div v-else-if="item.value === 'reported_time'">{{ item.after ? item.after : '--' }}</div>
              <div v-else-if="item.value === 'resolved_time'">{{ item.after ? item.after : '--' }}</div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
      </a-table>
    </a-skeleton>
    <preview-modal ref="previewModal" />
  </div>
</template>

<script>
import { problemRecord } from '@/api/event/problem';
import { problemUrgencys, problemChannels, problemFrequencys, problemTypes, problemStatus, faultLevels } from '@/utils/dictionary';

import PreviewModal from '@/pages/project/components/PreviewModal';
const columns = [
  {
    title: '序号',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: '10%',
    align: 'center',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: '15%',
    align: 'center',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: '10%',
    align: 'center',
    key: 'operation_alias',
    dataIndex: 'operation_alias'
  },
  {
    title: '变更项',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'diffItem' }
  },
  {
    title: '变更前',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'before' }
  },
  {
    title: '变更后',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'after' }
  }
];
export default {
  components: { PreviewModal },
  props: {
    sourceId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      faultLevels,
      problemTypes,
      problemStatus,
      problemUrgencys,
      problemChannels,
      problemFrequencys,
      spinning: true,
      projectId: parseInt(this.$route.params.project_id) || null,
      records: [],
      pagination: {
        size: 'small',
        total: 0,
        pageSize: this.$store.getters.pageSize, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      recordItems: {
        title: { value: 'title', label: '标题' },
        level: { value: 'level', label: '故障等级' },
        status: { value: 'status', label: '状态' },
        urgency: { value: 'urgency', label: '严重程度' },
        channel: { value: 'channel', label: '反馈去掉' },
        frequency: { value: 'frequency', label: '出现频率' },
        priority: { value: 'priority', label: '优先级' },
        solver: { value: 'solver', label: '解决人' },
        handler: { value: 'handler', label: '处理人' },
        reporter: { value: 'reporter', label: '反馈人' },
        content: { value: 'content', label: '描述' },
        tags: { value: 'tags', label: '标签' },
        domains: { value: 'domains', label: '业务域' },
        projects: { value: 'projects', label: '项目' },
        attribution: { value: 'attribution', label: '归因' },
        problem_type: { value: 'problem_type', label: '类型' },
        started_time: { value: 'started_time', label: '开始时间' },
        reported_time: { value: 'reported_time', label: '上报时间' }
      }
    };
  },
  computed: {
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(this.recordItems);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...this.recordItems[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    }
  },
  created() {
    if (this.sourceId !== null) this.getProblemRecord();
  },
  methods: {
    getProblemRecord() {
      problemRecord({
        id: this.sourceId,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.pagination.total = res.data.total;
          this.records = res.data.items.map((record, index) => {
            return {
              index: index + 1,
              ...record,
              value_diff: this.diff(record.value_diff)
            };
          });
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },

    onPreview(content, title = null) {
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, title);
      });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getProblemRecord();
    }
  }
};
</script>
<style lang="less" scoped>
.diff-item {
  display: block;
}

.ql-container.ql-snow {
  border: none;
}
</style>
